import React, { useEffect, useState } from "react";
import SignInMenuHeader from "../Authentication/SignInMenuHeader";
import { UserAuth } from "../Context";
import { Link } from "react-router-dom";
import "./style.css";
import { Button, Container, FormControl, Nav, Navbar } from "react-bootstrap";
import useSearchInputStore from "../StatesStore/SearchInputStore";
import UserMenuHeader4 from "../Authentication/UserMenuHeader4";

function Header() {
  const { user } = UserAuth();
  const [activeAccordion, setActiveAccordion] = useState(null);
  // const { isSearchBarOpen2, setIsSearchBarOpen2 } = useSearchBarOpen2State();
  // searchInput state is used to store user searchInput
  // const [searchInput, setSearchInput] = useState("");
  const {
    searchInput,
    setSearchInput,
    resetSearchInput,
  } = useSearchInputStore();
  // Handle outside click
  const handleOutsideClick = () => {
    const main = document.getElementById("main");
    // const navbarCollapsible = document.getElementById("navbarCollapse");
    const brand = document.getElementById("brandsCollapse");
    // const category = document.getElementById("categoryCollapse");
    const menCategory = document.getElementById("menCollapse");
    const womenCategory = document.getElementById("womenCollapse");

    setSearchInput(""); // Reset searchInput state to empty
    function fun() {
      if (main && main.classList.contains("show")) {
        main.setAttribute("data-bs-toggle", "collapse");
        main.setAttribute("data-bs-target", "#navbarCollapse");
      }
      if (user && brand && brand.classList.contains("show")) {
        brand.classList.remove("show");
      }
      // if (category.classList.contains("show")) {
      //   category.classList.remove("show");
      // }
      if (user && menCategory && menCategory.classList.contains("show")) {
        menCategory.classList.remove("show");
      }
      if (user && womenCategory && womenCategory.classList.contains("show")) {
        womenCategory.classList.remove("show");
      }

      setActiveAccordion(0);
      // document.querySelector(".brandsScrollBar").scrollTo(0, 0);
      // console.log(main);
      // console.log(navbarCollapsible);
    }
    setTimeout(fun, 400);
  };

  useEffect(() => {
    const main = document.getElementById("main");
    main.addEventListener("click", handleOutsideClick);
    // const brand = document.getElementById("brandsCollapse");
    // const category = document.getElementById("categoryCollapse");
    // brand.addEventListener("click", handleOutsideClick);
    // category.addEventListener("click", handleOutsideClick);

    setSearchInput("");
    return () => {
      main.removeEventListener("click", handleOutsideClick);
      // brand.removeEventListener("click", handleOutsideClick);
      // category.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchInput("");
    if (searchInput.length > 2) {
      window.location.href = `#/search/${searchInput}`;
    }
  };
  const handleLogoClick = () => {
    setSearchInput(""); // Reset searchInput state to empty
  };
  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between w-100 shadow-sm bg-mode border border-0 border-bottom"
        style={{ padding: "0px 20px", height: "60px" }}
      >
        {/* Logo START */}
        <Link
          className="text-body text-center fs-icon"
          to={user && "/"}
          onClick={handleLogoClick}
        >
          <div style={{ fontFamily: "Nunito Sans" }}>
            <i>lookflock &nbsp;</i>
          </div>
        </Link>
        {/* <a class="navbar-brand" href="index.html">
            <img
              class="light-mode-item navbar-brand-item"
              src="assets/images/logo.svg"
              alt="logo"
            />
            <img
              class="dark-mode-item navbar-brand-item"
              src="assets/images/logo.svg"
              alt="logo"
            />
          </a> */}
        {/* Logo END */}

        {/* Nav Search START */}
        {user && (
          <form className="position-relative" onSubmit={handleSearch}>
            <input
              style={{
                width: "400px",
                padding: "6px 8px 6px 28px",
                borderRadius: "12px",
                border: "0.86px solid #C3C3C3",
                fontSize: "14px",
                fontWeight: 400,
                color: "#676A79",
              }}
              type="search"
              name="searchInput"
              placeholder="Search"
              aria-label="Search"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button
              variant="mode"
              type="submit"
              className="bg-transparent position-absolute p-0 border-0"
              style={{ left: 0, top: "5.5px" }}
            >
              <svg
                style={{ width: "30px" }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.5077 8.40509C11.1961 8.43811 10.9702 8.71754 11.0032 9.02922C11.0363 9.3409 11.3157 9.56679 11.6274 9.53377L11.5077 8.40509ZM12.9086 10.2886C13.0308 10.5772 13.3638 10.7121 13.6525 10.5899C13.9411 10.4678 14.076 10.1347 13.9538 9.84611L12.9086 10.2886ZM15.2698 14.3706C15.048 14.1492 14.6887 14.1495 14.4673 14.3714C14.2458 14.5932 14.2462 14.9525 14.468 15.1739L15.2698 14.3706ZM17.0316 17.733C17.2534 17.9544 17.6127 17.9541 17.8342 17.7323C18.0556 17.5104 18.0553 17.1512 17.8334 16.9297L17.0316 17.733ZM11.6274 9.53377C12.1741 9.47584 12.6943 9.78233 12.9086 10.2886L13.9538 9.84611C13.5447 8.87961 12.5515 8.29449 11.5077 8.40509L11.6274 9.53377ZM14.468 15.1739L17.0316 17.733L17.8334 16.9297L15.2698 14.3706L14.468 15.1739Z"
                  fill="#676A79"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.46452 14.6808C6.76291 13.9773 6.28703 13.087 6.09593 12.1202C5.90323 11.1508 6.00218 10.1473 6.38068 9.23223C6.75594 8.32228 7.39661 7.5415 8.22224 6.98795C9.89738 5.86441 12.1026 5.86441 13.7777 6.98795C14.6034 7.5415 15.2441 8.32228 15.6193 9.23223C15.9978 10.1473 16.0968 11.1508 15.904 12.1202C15.713 13.087 15.2371 13.9773 14.5354 14.6808C13.6063 15.6172 12.3314 16.1453 11 16.1453C9.66861 16.1453 8.3937 15.6172 7.46452 14.6808Z"
                  stroke="#676A79"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </form>
        )}

        {/* Responsive navbar toggler */}
        {/* <div className="navbar-nav ms-auto bg-transparent">
            <button
              id="closeNav"
              className="d-none d-lg-block border border-0 nav-link ms-auto bg-transparent"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={handleOutsideClick}
            >
              Menu
              <i className="fs-6 bi bi-chevron-down px-2"></i>
            </button>
            <button
              className="d-lg-none d-block navbar-toggler ms-auto icon-md btn btn-light p-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
              </span>
            </button>
          </div> */}

        {/* Nav right START */}
        <div
          className="d-flex align-items-center position-relative"
          style={{ gap: "12px" }}
        >
          {user ? <UserMenuHeader4 /> : <SignInMenuHeader />}
        </div>
      </div>
      {/* <Navbar className="shadow-sm bg-mode border border-0 border-bottom">
        <Container className="text-center align">
          <Link
            className="text-body text-center fs-icon"
            to="/"
            onClick={handleLogoClick}
          >
            <div style={{ fontFamily: "Nunito Sans" }}>
              <i>lookflock &nbsp;</i>
            </div>
          </Link>
          <style jsx>
            {`
              .searchBarFull {
                width: 2.5rem;
                transition: width 0.2s ease;
              }
              .searchBarFull.show {
                width: 23rem;
              }
            `}
          </style>
          <Nav className="nav mt-0 flex-nowrap justify-content align-items-center px-0 ms-auto">
            <Nav.Item>
              <form
                className={`rounded position-relative searchBarFull ${
                  isSearchBarOpen2 ? "show" : ""
                }`}
                onSubmit={handleSearch}
              >
                <FormControl
                  className={`${
                    isSearchBarOpen2 ? "ps-5 bg-light" : "ps-2 border-0"
                  } `}
                  type="search"
                  name="searchInput"
                  placeholder={isSearchBarOpen2 ? "Search..." : ""}
                  aria-label="Search"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <Button
                  variant="mode"
                  type="submit"
                  className="bg-transparent px-2 py-0 position-absolute top-50 start-0 translate-middle-y"
                  onClick={() => {
                    setIsSearchBarOpen2(!isSearchBarOpen2);
                  }}
                >
                  <i className="bi bi-search fs-4"></i>
                </Button>
              </form>
            </Nav.Item>
          </Nav>
          <ul className="nav flex-nowrap align-items-center list-unstyled position-relative ps-2 gap-2">
            {user ? <UserMenuHeader4 /> : <SignInMenuHeader />}
          </ul>
        </Container>
      </Navbar> */}

      {/* Collapsed Content */}
      {/* <div className="bg-mode collapse navbar-collapse" id="navbarCollapse">
        <div className="py-4 container">
          <HeaderMenu2
            setSearchInput={setSearchInput}
            // handleOutsideClick={handleOutsideClick}
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
          />
        </div>
      </div> */}
    </>
  );
}

export default Header;
